export enum DEFAULT_IMG {
    logo_crop = 'assets/img/logo_crop.svg'
}